import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowsPage.XeroWorkflowList', {
    payableGroup: 'Accounts payable',
    receivableGroup: 'Accounts receivable',
    otherGroup: 'Other',
    advanceableGroup: 'Other workflows',
});
